import { ITable } from '@/components/TableAction/TableAction';
import { Carrier } from './order';

// interface column tab Ready to Ship
export interface OrderDataReady extends ITable {
  orderDate: string;
  orderId: string;
  customerName: string;
  customerAddress: string;
  quantity: number;
  totalValue: string;
}

// interface column tab InProgress
export interface OrderDataInProgress extends ITable {
  orderDate: string;
  orderId: string;
  customerName: string;
  customerAddress: string;
  pickupLocation: string;
  product: string;
  status: string;
}

// interface column tab OnHold
export interface OrderDataOnHold extends ITable {
  orderDate: string;
  orderId: string;
  customerName: string;
  customerAddress: string;
  pickupLocation: string;
  product: string;
  status: string;
}
// interface column tab RTO
export interface OrderDataRTO extends ITable {
  time: string;
  dropOffLocation: string;
  driver: {
    image: string;
    name: string;
    phone: string;
  };
  status: string;
}
// export interface OrderDataRTO extends ITable {
//   orderDate: string;
//   orderId: string;
//   customerName: string;
//   customerAddress: string;
//   pickupLocation: string;
//   product: string;
//   status: string;
// }

// interface column tab finished
export interface OrderDataFinished extends ITable {
  orderDate: string;
  orderId: string;
  customerName: string;
  customerAddress: string;
  quantity: number;
  totalValue: string;
  status: string;
}

export enum OrderStatusTab {
  READY_TO_SHIP = 'ready_to_ship',
  IN_PROGRESS = 'in_progress',
  ON_HOLD = 'on_hold',
  RTO = 'return_to_origin',
  INVENTORY = 'inventory',
  FINISHED = 'finished',
}

export enum RemittanceStatus {
  INITIATED = 'initiated',
  DELIVERED = 'delivered',
  CANCELLED = 'cancelled',
  REQUESTED = 'requested',
  READY_TO_PICKUP = 'ready_to_pickup',
}
export enum PickupStatus {
  NEW = 'new',
  OUT_FOR_COLLECTION = 'out-for-collection',
  CANCELLED = 'cancelled',
  BULK_COLLECTED = 'bulk-collected',
  COLLECTED = 'collected',
}

export enum StatusEnum {
  COLLECTING = 'Collecting',
  NEW = 'New',
}

export interface CsvData extends ITable {
  key: string;
  label: string;
  value: string;
}

export interface OrderDataImport {
  key: string;
  validity: string;
  orderId: string;
  customerName: string;
  customerPhone: string;
  customerAddress: string;
  quantity: number;
  total: number;
  packageSize: string;
  orderPayment: string;
  shipmentPayment: string;
  errors: any;
  carrierList: Carrier[];
  process_id?: string | null;
  recommended_carrier_slug?: string | null;
  selected_carrier_slug?: string | null;
  has_carrier_error?: boolean;
  carrier_error_message?: string | null;
  available_carriers_detail?: string | null;
  // Item 2 — name/uid of the shipping rule that produced the row's
  // recommended carrier. Null when no rule matched.
  recommended_rule_name?: string | null;
  recommended_rule_uid?: string | null;
  availableCarriersParsed?: Array<{
    carrier_slug: string;
    carrier_name: string;
    logo_url: { abs_url: string };
    shipping_fee: number;
    delivery_day: number;
  }>;
  validation_status?: 'INVALID' | 'VALID';
}

export enum FinanceTab {
  Balance = 'balance',
  COD = 'cod_remittances',
  Transactions = 'transactions',
}

export interface RemittanceRecord {
  key: string;
  date: string;
  remittanceId: string;
  amount: string;
  status: string;
}

export interface FinanceCOD extends ITable {
  date: string;
  remittanceId: string;
  amount: string;
  eta: string;
  status: string;
  statusSlug: string;
  payment_method?: string;
  orders_count?: number;
  paid_to?: string;
}

export interface FinanceTransaction extends ITable {
  date: string;
  transactionId: string;
  orderId?: string;
  order_uid?: string | null;
  order_platform_code?: string | null;
  title: string;
  details?: string;
  amount: string;
  is_correction: 1 | 0;
  status?: string;
}
